import { render } from "./SimpleTextarea.vue?vue&type=template&id=4e27da5b&scoped=true&ts=true"
import script from "./SimpleTextarea.vue?vue&type=script&lang=ts"
export * from "./SimpleTextarea.vue?vue&type=script&lang=ts"

import "./SimpleTextarea.vue?vue&type=style&index=0&id=4e27da5b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e27da5b"]])

export default __exports__